import styled from 'styled-components';
import { motion, useInView } from 'motion/react';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';
import { device } from '../../../constants';
import { useRef } from 'react';

interface MotionProjectImageProps {
  src: string;
  alt: string;
  draggable?: boolean;
}

export const MotionProjectImage = ({
  src,
  alt,
  draggable,
}: MotionProjectImageProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <MotionProjectImageWrapper
      ref={ref}
      initial={{ opacity: 0, scale: 0 }}
      animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0 }}
      transition={{
        duration: ANIMATION_CONFIG.projectImage.duration,
        type: 'spring',
      }}
    >
      <ProjectImage src={src} alt={alt} draggable={draggable} />
    </MotionProjectImageWrapper>
  );
};

const MotionProjectImageWrapper = styled(motion.div)`
  width: 100%;
  height: 100%;
`;

const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-height: 100%;
  will-change: transform, opacity;
  content-visibility: auto;

  @media screen and (${device.md}) {
    height: 500px;
  }
  @media screen and (${device.sm}) {
    height: 300px;
  }
`;
